(function () {
  var button = document.getElementById('back-to-top');
  if (!button) return;

  function toggleVisibility() {
    if (window.scrollY > 500) {
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
